export interface TmtErpOutboundOption {
  value: string;
  label: string;
}

export const TMT_ERP_OUTBOUND_RESPONSE_TYPE_OPTIONS: TmtErpOutboundOption[] = [
  {value: 'UpdateInvoiceDetails', label: 'Invoice'},
  {value: 'UpdateTrailerID', label: 'Trailer'},
];

export const TMT_ERP_OUTBOUND_RESULT_OPTIONS: TmtErpOutboundOption[] = [
  {value: 'Invoiced', label: 'Invoiced'},
  {value: 'OK', label: 'OK'},
  {value: 'InterpretationError', label: 'Failed'},
  {value: 'InvoiceError', label: 'Error'},
  {value: 'TicketForVoidNotFound', label: 'Void Ticket Not Found'},
  {value: 'PENDING', label: 'Pending'}
];

export function isTmtErpOutboundError(result: string | null, errorDescription?: string | null): boolean {
  if (errorDescription && errorDescription.trim()) return true;
  if (!result) return false;

  const v = result.toLowerCase();
  return v.includes('fail') || v.includes('error') || v.includes('notfound');
}

export function tmtErpOutboundResultChipStyle(value: string | null): Record<string, string> {
  if (!value) return {};

  const v = value.toLowerCase();
  let background = '#eceff1';
  let color = '#37474f';

  if (v.includes('success') || v.includes('complete') || v === 'ok' || v.includes('processed')) {
    background = '#e6f4ea';
    color = '#1e7e34';
  } else if (v.includes('fail') || v.includes('error') || v.includes('reject')) {
    background = '#fdecea';
    color = '#c62828';
  } else if (v.includes('warn') || v.includes('partial') || v.includes('pending') || v.includes('retry')) {
    background = '#fff8e1';
    color = '#8a6d00';
  }

  return {
    'background-color': background,
    color,
    'font-weight': '600',
    'border-radius': '12px',
    padding: '2px 12px',
    'text-align': 'center',
    'white-space': 'nowrap',
  };
}
